import React from 'react';
import alpinist from '../images/alpinist-black.png'

const imgStyle = {
    width: '128px',
    verticalAlign: 'middle'
  };

  const topStyle = {
    textAlign: 'center',
    margin: '0 auto',
    padding: '5rem 0 2rem',
    maxWidth: '900px'
  }

  const h3Style = {
    borderBottom: '4px solid rgba(0, 0, 0, 0.87)',
    paddingBottom: '8px',
    paddingTop: '2px',
    marginBottom: '24px',
    fontSize: '32px',
    fontWeight: 'bold'
  }

  const pStyle = {
      fontSize: '22px',
      fontStyle: 'italic'
  }

const Mid1 = () => (
    <div style={topStyle}>
        <img style={imgStyle} src={alpinist} alt="alpinist" />
        <h3 style={h3Style}>GO PLACES OTHERS WON'T</h3>
        <p style={pStyle}>We work with carefully selected local experts to come up with unique 
        routes and experiences just for you. They know how to show you a good time 
        and stay safe in the wild.</p>
    </div>
)

export default Mid1;